module.exports = __webpack_public_path__ + "img/logo-paoli.4e7e9103.png";